import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import { useReloginDialogStore } from '@/stores/relogin-dialog'
import { isPostHogEnabled, posthog } from '@/lib/posthog'
import { moduleFromPathname } from '@/lib/analytics-modules'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const apiViagem = axios.create({
  baseURL: import.meta.env.VITE_API_VIAGEM_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

for (const instance of [api, apiViagem]) {
  instance.interceptors.request.use((config) => {
    const token = useAuthStore.getState().accessToken

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  })

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const isAuthEndpoint = error.config?.url?.includes('/Auth')
        const isAuthenticated = useAuthStore.getState().isAuthenticated()

        if (!isAuthEndpoint && isAuthenticated) {
          if (isPostHogEnabled) {
            posthog.capture('bo_session_expired', {
              last_active_module: moduleFromPathname(window.location.pathname),
            })
          }
          useReloginDialogStore.getState().open()
          return new Promise(() => {})
        }
      } else if (isPostHogEnabled) {
        posthog.capture('bo_api_error', {
          module: moduleFromPathname(window.location.pathname),
          endpoint: error.config?.url,
          http_status: error.response?.status,
        })
      }

      return Promise.reject(error)
    },
  )
}
